import { useMutation } from "@tanstack/react-query";
import { SyncUsersFormData } from "../schema/SyncUsersSchema";
import { privateApi } from "../../../api/api";
import { AssignResponse } from "../response/AssignResponse";
import { ValidationErrorResponse } from "../response/ValidationErrorResponse";

interface useAssignUsersProps {
    roleId: number | undefined;
}

export const useAssignUsers = ({ roleId }: useAssignUsersProps) => {
    return useMutation({
        mutationKey: ['role', 'assign', 'users', roleId],
        mutationFn: async (formData: SyncUsersFormData) => privateApi.post(`/v4/role/${roleId}/sync-users`, formData),
        onSuccess: async (response) => {
            try {
                const validationResult = AssignResponse.safeParse(response.data);

                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid assign user data format");
                }

                return validationResult.data
            } catch (error) {
                console.error('Failed to create assign user', error);
                throw error;
            }
        },
        onError: (error) => {
            const validationResult = ValidationErrorResponse.safeParse((error as any).response.data);

            if (!validationResult.success) {
                console.error("Validation failed:", validationResult.error.errors);
                throw new Error("Invalid assign users data format");
            } else {
                console.error(`Failed to assign users`, error);
                throw error;
            }
        }
    })
};